'use client'

import { useEffect } from 'react'
import clarity from '@microsoft/clarity'

export type MicrosoftClarityProps = {
  projectId?: string | null
}

export function MicrosoftClarity({ projectId }: MicrosoftClarityProps) {
  useEffect(() => {
    if (!projectId) return

    try {
      clarity.init(projectId)
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[MicrosoftClarity] Failed to initialize', error)
      }
    }
  }, [projectId])

  return null
}
